<template>
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <b-overlay
        :show="loadingTree"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-card body-class="px-0">
          <div class="search-folder px-1">
            <div class="input-group mb-1">
              <input
                v-model="searchCatQuery"
                class="form-control"
                type="text"
                placeholder="tên phòng ban"
                aria-label="tên phòng ban"
                size="sm"
                @input="filterPem"
              >
              <div class="input-group-append">
                <span
                  v-if="!searchCatQuery.length"
                  class="input-group-text"
                ><feather-icon icon="SearchIcon" /></span>
                <span
                  v-if="searchCatQuery.length"
                  class="input-group-text"
                  @click="filterPem($event, true)"
                ><feather-icon icon="XIcon" /></span>
              </div>
            </div>
          </div>
          <vue-tree-list
            :model="treeData"
            :default-expanded="true"
            @drop="onDrop"
            @drop-before="onDropBefore"
            @drop-after="onDropAfter"
          >
            <template v-slot:leafNameDisplay="item">
              <span class="name">
                <span @click="clickEdit(item.model.id)">{{ item.model.name }} ({{ item.model.code }})</span>
                <b-badge
                  v-if="item.model.is_director"
                  variant="light-primary"
                >
                  Phòng giám đốc
                </b-badge>
              </span>
              <span class="action">
                <span
                  title="Up"
                  class="icon"
                  @click.prevent="changePosition(item.model.id, 'up')"
                >
                  <feather-icon icon="CornerLeftUpIcon" />
                </span>
                <span
                  title="Down"
                  class="icon"
                  @click.prevent="changePosition(item.model.id, 'down')"
                >
                  <feather-icon icon="CornerRightDownIcon" />
                </span>
                <span
                  title="Sửa"
                  class="icon"
                  @click.prevent="clickEdit(item.model.id)"
                >
                  <feather-icon icon="Edit3Icon" />
                </span>
                <span
                  title="Xóa"
                  class="icon"
                  @click.prevent="confirmDelete(item.model.id, item.model.name)"
                >
                  <feather-icon icon="XIcon" />
                </span>
              </span>
            </template>
            <span
              slot="addTreeNodeIcon"
              class="icon"
            />
            <span
              slot="addLeafNodeIcon"
              class="icon"
            />
            <span
              slot="editNodeIcon"
              title="Sửa"
              class="icon"
              @click.prevent="clickEdit($event)"
            >
              <feather-icon icon="Edit3Icon" />
            </span>
            <span
              slot="delNodeIcon"
              title="Xóa"
              class="icon"
              @click.prevent=""
            >
              <feather-icon icon="XIcon" />
            </span>
            <span
              slot="leafNodeIcon"
              class="icon"
              @click.prevent=""
            >
              <feather-icon icon="CircleIcon" />
            </span>
            <span
              slot="treeNodeIcon"
              class="icon"
            ><feather-icon icon="CircleIcon" /></span>
          </vue-tree-list>

        </b-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import {
  BCard, BBadge, BOverlay, BButton,
} from 'bootstrap-vue'
import { showToast } from '@/@core/utils/utils'
// import { faL } from '@fortawesome/free-solid-svg-icons'
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'

export default {
  name: 'Hello',
  components: {
    BCard,
    BBadge,
    BButton,
    BOverlay,
    VueTreeList,
  },
  props: {
    itemsDataTree: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      defaultNodeOptions: {
        isLeaf: true,
        dragDisabled: true,
        addTreeNodeDisabled: true,
        addLeafNodeDisabled: true,
        editNodeDisabled: true,
        delNodeDisabled: true,
        disabled: true,
        itemType: 'category',
        show: true,

      },
      newTree: [],
      // treeData: new Tree([]),
      searchCatQuery: '',
    }
  },
  computed: {
    loadingTree: {
      get() { return this.loading },
      set(val) {
        this.$emit('update:loading', val)
      },
    },
    treeData() {
      const rootNodeOptions = { ...this.defaultNodeOptions };
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.newTree = [];
      this.itemsDataTree.forEach((root) => {
        let allowCreateSub = true;
        if (root.type === 'all') {
          allowCreateSub = false;
        }
        const item = {
          id: root.id,
          pid: root.parent_id < 0 ? 0 : root.parent_id,
          name: root.name,
          level: root.level,
          type: root.type,
          is_director: root.is_director,
          allow_delete: true,
          code: root.code,
          position: root.position,
          ...rootNodeOptions,
          children: [],
        };
        // console.log('root:', root);
        // force sub cat is leaf
        if (root.childrens.length) {
          root.childrens.forEach((c1) => {
            const item1 = {
              id: c1.id,
              pid: c1.parent_id,
              name: c1.name,
              code: c1.code,
              level: c1.level,
              type: c1.type,
              is_director: c1.is_director,
              allow_delete: true,
              position: c1.position,
              ...this.getLeafNodeOptions(),
              children: [],
            }
            if (c1.childrens.length) {
              c1.childrens.forEach((c2) => {
                const item2 = {
                  id: c2.id,
                  pid: c2.parent_id,
                  name: c2.name,
                  code: c2.code,
                  level: c2.level,
                  type: c2.type,
                  is_director: c2.is_director,
                  allow_delete: true,
                  position: c2.position,
                  ...this.getLeafNodeOptions(),
                  children: [],
                }
                if (c2.childrens.length) {
                  c2.childrens.forEach((c3) => {
                    const item3 = {
                      id: c3.id,
                      pid: c3.parent_id,
                      name: c3.name,
                      code: c3.code,
                      level: c3.level,
                      type: c3.type,
                      is_director: c3.is_director,
                      allow_delete: true,
                      position: c3.position,
                      ...this.getLeafNodeOptions(),
                      children: [],
                    }
                    if (c3.childrens.length) {
                      c3.childrens.forEach((c4) => {
                        const item4 = {
                          id: c4.id,
                          pid: c4.parent_id,
                          name: c4.name,
                          code: c4.code,
                          level: c4.level,
                          type: c4.type,
                          is_director: c4.is_director,
                          allow_delete: true,
                          position: c4.position,
                          ...this.getLeafNodeOptions(),
                          children: [],
                        }
                        if (c4.childrens.length) {
                          c4.childrens.forEach((c5) => {
                            const item5 = {
                              id: c5.id,
                              pid: c5.parent_id,
                              name: c5.name,
                              code: c5.code,
                              level: c5.level,
                              type: c5.type,
                              is_director: c5.is_director,
                              allow_delete: true,
                              position: c5.position,
                              ...this.getLeafNodeOptions(),
                              children: [],
                            }
                            item4.children.push(item5);
                          })
                        }
                        item3.children.push(item4);
                      })
                    }
                    item2.children.push(item3);
                  })
                }
                item1.children.push(item2);
              })
            }
            item.children.push(item1);
          })
        }
        return this.newTree.push(item);
      });
      // console.log('newTree', JSON.stringify(this.newTree));
      return new Tree(this.newTree);
    },
  },
  methods: {
    activeNodeTree(nodeId) {
      const allNodes = document.querySelectorAll('.vtl-node');
      allNodes.forEach((val) => {
        const id = parseInt(val.getAttribute('id'), 0);
        if (id !== nodeId) {
          val.classList.remove('active');
        } else {
          val.classList.add('active');
        }
      });
    },
    clickNodeTree(params) {
      if (params) {
        this.activeNodeTree(params.id);
      }
    },
    getRootNodeOptions() {
      return { ...this.defaultNodeOptions };
    },
    getLeafNodeOptions() {
      const leafNodeOptions = { ...this.defaultNodeOptions };
      leafNodeOptions.isLeaf = true;
      leafNodeOptions.editNodeDisabled = true;
      leafNodeOptions.delNodeDisabled = true;
      return leafNodeOptions;
    },
    deleteNodeTree(rootNodes, node) {
      node.remove();
    },
    onEdit(node) {

    },
    clickEdit(id) {
      if (id) {
        setTimeout(() => {
          this.$router.push({ name: 'departments-edit', params: { id } });
        }, 0)
      }
      return false;
    },
    onDrop(node) {
      // console.log('onDrop', node);
    },
    onDropBefore(node) {
      // console.log('onDropBefore', node);
    },
    onDropAfter(node) {
      // console.log('onDropAfter', node);
    },
    confirmDelete(id, name) {
      // const el = document.getElementById(node.id);
      // el.focus();
      this.$swal({
        title: `Bạn chắc muốn xóa ${name}?`,
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.loadingTree = true
          this.$store.dispatch('departments/deleteDepartment', { id }).then((res) => {
            this.loadingTree = false
            if (res.status === 200) {
              // this.deleteNodeTree(this.newTree, node);
              if (res.data.code === 200) {
                // this.clickNodeTree(node);
                this.$emit('reload-data');
                showToast(res.data.message, { variant: 'success' });
              } else {
                showToast(res.data.message)
              }
            }
          })
        }
      })
    },
    findParent(child, parentClass) {
      let parent = child.parentElement;
      while (parent) {
        if (parent.classList.contains(parentClass)) {
          break;
        }
        parent = parent.parentElement;
      }
      return parent;
    },
    filterPem(event, clear) {
      const isClear = clear === undefined ? false : clear;
      const filter = this.searchCatQuery.toLowerCase();
      if (clear) {
        this.searchCatQuery = '';
      }
      const nodes = document.querySelectorAll('.vtl-node');
      nodes.forEach(el => {
        if (!isClear) {
          const nodeName = el.querySelector('.vtl-node-content').innerText;
          if (nodeName.toLowerCase().indexOf(filter) > -1) {
            el.style.display = '';
            let parent = el.closest('.vtl-tree-margin') ? el.closest('.vtl-tree-margin').closest('.vtl') : null;
            while (parent) {
              parent.querySelector('.vtl-node').style.display = '';
              parent = parent.closest('.vtl-tree-margin') ? parent.closest('.vtl-tree-margin').closest('.vtl') : null;
              if (parent) {
                parent.querySelector('.vtl-node').style.display = '';
              }
            }
          } else {
            el.style.display = 'none';
          }
        } else {
          el.style.display = '';
        }
      });
    },

    changePosition(id, dir) {
      this.loadingTree = true
      this.$store.dispatch('departments/updatePosition', { id, departmentData: { dir } })
        .then((res) => {
          this.loadingTree = false
          if (res.status === 200) {
            if (res.data.code === 200) {
              showToast(res.data.message, { variant: 'success' });
              this.$emit('reload-data');
            } else {
              showToast(res.data.message)
            }
          }
        })
    },
  },
}
</script>

<style lang="scss">
.vtl {
  .icon {
    margin-right: 5px;

    &:hover {
      cursor: pointer;
    }
  }

  .muted {
    color: gray;
    font-size: 80%;
  }

  .vtl-caret {
    margin-top: 3px;
  }

  .vtl-node-main {
    padding-left: 2rem;
    display: flex;
  }

  .vtl-tree-margin {
    margin-left: 1rem;
  }

  .vtl-node-content {
    cursor: pointer;
    display: flex;
    flex: 1;
  }

  .vtl-node-content .action {
    margin-left: auto;
    display: none;

    span {
      margin-left: 10px;
    }
  }

  .vtl-node-main .vtl-operation {
    text-align: right;
    margin-left: auto;
  }

  .vtl-node-main .vtl-operation span {
    margin-right: 5px;
  }

  .vtl-node:focus {
    background-color: #f0f0f0;
  }

  .vtl-node:hover .action {
    display: block;
  }

}
</style>
